import React from 'react';
import { Checkboxes } from 'mui-rff';

interface BokunTermAgreementsProps {
    termsApiAgreed?: boolean;
    termsPartnerAgreed?: boolean;
}

export const BokunTermAgreements = ({
    termsApiAgreed = false,
    termsPartnerAgreed = false,
}: BokunTermAgreementsProps): JSX.Element => (
    <>
        <Checkboxes
            required={true}
            name={'termsApiAgreed'}
            data={{
                value: termsApiAgreed,
                label: (
                    <>
                        <span>
                            I agree to the{' '}
                            <a
                                href={'https://www.bokun.io/legal/api-terms'}
                                target={'_blank'}
                                rel={'noreferrer noopener'}
                            >
                                Bókun API terms
                            </a>
                        </span>
                    </>
                ),
            }}
        />
        <Checkboxes
            required={true}
            name={'termsPartnerAgreed'}
            data={{
                value: termsPartnerAgreed,
                label: (
                    <>
                        <span>
                            I agree to the{' '}
                            <a
                                href={'https://www.bokun.io/legal/app-store-partner-agreement'}
                                target={'_blank'}
                                rel={'noreferrer noopener'}
                            >
                                Bókun Partner terms
                            </a>
                        </span>
                    </>
                ),
            }}
        />
    </>
);
